import { render, staticRenderFns } from "./WatingNewRequests.vue?vue&type=template&id=71d28299&"
import script from "./WatingNewRequests.vue?vue&type=script&lang=js&"
export * from "./WatingNewRequests.vue?vue&type=script&lang=js&"
import style0 from "./WatingNewRequests.vue?vue&type=style&index=0&id=71d28299&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports